export default __webpack_public_path__ + "static/media/m-slide-3.624a7320.png";